import React, { useEffect, useState } from 'react';

import Fade from '@material-ui/core/Fade';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Grid, makeStyles } from '@material-ui/core';

import {
  getCountersDataAction,
  getInfoChartsAction,
} from '../../actions/dashboardAction';
import {
  getEmployeeContractToFinish,
  setEmployeeFilter,
} from '../../actions/employeeActions';
import BannerEmployee from './Components/BannerEmployee';
import {
  BiBarChart,
  CardChart,
  PieChartComp,
  RadialBarComp,
  VerticalBar,
} from './Components/charts';
import { HorizontalBar } from './Components/charts/HorizontalBar';
import { LicenseInfoCard } from './licenseInfoCard';

const useStyles = makeStyles(theme => ({
  contRoot: {
    padding: 1,

    [theme.breakpoints.down('sm')]: {
      width: '95vw',
    },

    [theme.breakpoints.up('sm')]: {
      width: '68vw',
    },
    [theme.breakpoints.up('md')]: {
      width: '75vw',
    },
    [theme.breakpoints.up('lg')]: {
      width: '80vw',
    },
    [theme.breakpoints.up('xl')]: {
      width: '86vw',
    },
  },
  containerRight: {
    paddingLeft: '15px !important',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '30px !important',
      paddingTop: '15px !important',
    },
  },
  containerLeft: {
    paddingLeft: '30px !important',
    paddingTop: '15px !important',
  },
  pageContainer: {
    opacity: 1,
    transition: 'opacity 0.5s ease-in-out',
  },
  pageFading: {
    opacity: 0,
  },
}));

export const Home = () => {
  moment.locale('es');
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useHistory();

  const [licence, setLicence] = useState({
    billings: 0,
    employees: 0,
    showbillings: true,
    showemployees: true,
  });
  const [fadeIn, setFadeIn] = useState(false);
  const [isExiting, setIsExiting] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [showBannerLicence, setShowBannerLicence] = useState(true);

  const { counterData, loadingCounter, infoCharts, loadingInfoCharts } =
    useSelector(s => s.dashboardReducer);
  const { employeeContractToFinish, filterEmployee } = useSelector(
    s => s.employeeReducer
  );

  const {
    behaviorMonth,
    concepts,
    documentsTransmitted,
    employeesConfirmed,
    employeesTransmitted,
    payrollPayment,
  } = infoCharts;

  const goToLicences = () => {
    setIsExiting(true);
    setTimeout(() => {
      navigate.push('/licences');
    }, 300);
  };

  /**
   * Cargue Inicial
   */
  useEffect(() => {
    dispatch(getCountersDataAction());
    dispatch(getInfoChartsAction());
    dispatch(getEmployeeContractToFinish());
    setTimeout(() => {
      setFadeIn(true);
    }, 100);
  }, [dispatch]);

  useEffect(() => {
    employeeContractToFinish && setShowBanner(true);
  }, [employeeContractToFinish]);

  /**
   * Carga información licencia
   */
  useEffect(() => {
    if (!!counterData) {
      let document = false;
      let employe = false;
      if (
        (counterData.licenciaDocumentosDisponible === 0 &&
          counterData.licenciaEmpleadosDisponible === 0) ||
        counterData.licenciaDocumentosDisponible > 0
      ) {
        document = true;
      }

      if (
        (counterData.licenciaDocumentosDisponible === 0 &&
          counterData.licenciaEmpleadosDisponible === 0) ||
        counterData.licenciaEmpleadosDisponible > 0
      ) {
        employe = true;
      }

      setLicence({
        billings: counterData?.licenciaDocumentosDisponible ?? 0,
        employees: counterData?.licenciaEmpleadosDisponible ?? 0,
        showbillings: document,
        showemployees: employe,
      });
    }
  }, [counterData]);

  const getNameMonth = () => {
    const monthNames = [
      'ENERO',
      'FEBRERO',
      'MARZO',
      'ABRIL',
      'MAYO',
      'JUNIO',
      'JULIO',
      'AGOSTO',
      'SEPTIEMBRE',
      'OCTUBRE',
      'NOVIEMBRE',
      'DICIEMBRE',
    ];

    const d = new Date();
    return monthNames[d.getMonth()];
  };

  // obtener año actual  con date fns
  const getYear = () => {
    const date = new Date();
    return date.getFullYear();
  };

  const handleCloseBanner = () => {
    setShowBanner(false);
  };

  const handleClickHereBanner = () => {
    navigate.push('/employee');
    dispatch(setEmployeeFilter({ ...filterEmployee, contractToFinish: true }));
  };

  return (
    <Fade in={fadeIn && !isExiting} timeout={500}>
      <div
        className={`${classes.pageContainer} ${
          isExiting || !fadeIn ? classes.pageFading : ''
        }`}
      >
        <div className={classes.contRoot}>
          <Grid container spacing={1} alignContent="center">
            {showBanner && (
              <Grid item xl={12} lg={12} xs={12}>
                <BannerEmployee
                  message="Algunos de tus empleados finalizan su contrato en el transcurso de
              este mes, al cumplir ese tiempo se retirarán automáticamente de la
              plataforma. En caso de continuar trabajando, por favor revísalos y de
              ser necesario actualiza su información dando"
                  linkText="Clic aquí"
                  onClose={handleCloseBanner}
                  onClickHere={handleClickHereBanner}
                  severity="warning"
                />
              </Grid>
            )}
            {showBannerLicence && (
              <Grid item xl={12} lg={12} xs={12}>
                <BannerEmployee
                  message="Tienes acceso a los siguientes planes para más detalles de cómo funcionan"
                  linkText="Haz clic aquí "
                  onClose={() => setShowBannerLicence(false)}
                  onClickHere={goToLicences}
                  severity="warning"
                  customMargin="0rem 0.3rem 1rem 1.8rem"
                />
              </Grid>
            )}
            <Grid item xl={5} lg={5} md={12} xs={12}>
              <Grid container spacing={2} style={{ paddingLeft: 25 }}>
                <Grid item lg={6} xs={6}>
                  <LicenseInfoCard
                    title={licence.employees}
                    subtitle={`Empleados Disponibles ${getNameMonth()}`}
                    loading={loadingCounter}
                  />
                </Grid>

                {licence.showbillings && (
                  <Grid item lg={6} xs={6}>
                    <LicenseInfoCard
                      title={licence.billings}
                      subtitle={'Documentos Disponibles'}
                      loading={loadingCounter}
                    />
                  </Grid>
                )}
                <Grid item lg={12} xs={12}>
                  <CardChart
                    title={`Comportamiento empleados ${getNameMonth()} ${getYear()}`}
                    componentProp={
                      <VerticalBar behaviorMonth={behaviorMonth} />
                    }
                    loading={loadingInfoCharts}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xl={7}
              lg={7}
              md={12}
              xs={12}
              className={classes.containerRight}
            >
              <Grid container spacing={2}>
                <Grid item lg={12} xs={12}>
                  <CardChart
                    title={`Porcentaje nóminas confirmadas ${getNameMonth()} ${getYear()} (conceptos)`}
                    componentProp={<PieChartComp concepts={concepts} />}
                    loading={loadingInfoCharts}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid
              item
              xl={12}
              lg={12}
              xs={12}
              className={classes.containerLeft}
            >
              <CardChart
                title={'Pago de nómina últimos 6 meses '}
                componentProp={
                  <HorizontalBar payrollPayment={payrollPayment} />
                }
                loading={loadingInfoCharts}
              />
            </Grid>
            <Grid item xl={5} lg={5} xs={12} className={classes.containerLeft}>
              <CardChart
                title={`Empleados confirmados y trasmitidos ${getNameMonth()} ${getYear()}`}
                componentProp={
                  <RadialBarComp
                    employeesTransmitted={employeesTransmitted}
                    employeesConfirmed={employeesConfirmed}
                  />
                }
                loading={loadingInfoCharts}
              />
            </Grid>
            <Grid
              item
              xl={7}
              lg={7}
              xs={12}
              className={classes.containerRight}
              style={{ paddingTop: 15 }}
            >
              <CardChart
                title={'Detalle documentos transmitidos a DIAN últimos 6 meses'}
                componentProp={
                  <BiBarChart documentsTransmitted={documentsTransmitted} />
                }
                loading={loadingInfoCharts}
              />
            </Grid>
          </Grid>
        </div>
      </div>
    </Fade>
  );
};
